module.exports = __webpack_public_path__ + "static/media/3.47582187.svg";